import { ToasterContent } from './ToasterContent';
import { ToastViewport } from './ToastViewport';

/**
 * Renders the Toaster component.
 * The Toaster component displays toast notifications.
 */
export const Toaster = () => {
  return (
    <>
      <ToasterContent />
      <ToastViewport />
    </>
  );
};
